<script lang="ts">
	import { WidgetState } from '../lib/widget.svelte';
	import LoaderScreen from './LoaderScreen.svelte';
	import TemplateGallery from './TemplateGallery.svelte';
	import CameraCapture from './CameraCapture.svelte';
	import EditorCanvas from './EditorCanvas.svelte';

	interface Props {
		apiUrl: string;
		clientToken: string;
		campaignToken: string;
		galleryMode?: 'grid' | 'carousel';
		customTips?: string[];
	}

	let { apiUrl, clientToken, campaignToken, galleryMode = 'grid', customTips = [] }: Props = $props();

	const widget = new WidgetState(apiUrl, clientToken, campaignToken);

	$effect(() => {
		widget.boot();
	});
</script>

<div class="ss-widget">
	{#if widget.data}
		<header class="ss-header">
			{#if widget.data.client.logo_url}
				<img src={widget.data.client.logo_url} alt={widget.data.client.name} />
			{/if}
			<div>
				<div class="ss-title">{widget.data.campaign.name}</div>
				<div class="ss-subtitle">{widget.data.client.name}</div>
			</div>
		</header>
	{/if}

	<div class="ss-body">
		{#if widget.step === 'boot'}
			<LoaderScreen {widget} tips={customTips} />
		{:else if widget.step === 'gallery'}
			<TemplateGallery {widget} mode={galleryMode} />
		{:else if widget.step === 'camera'}
			<CameraCapture {widget} />
		{:else if widget.step === 'processing'}
			<div class="ss-loader">
				<div class="ss-spinner"></div>
				<h3>Recortando tu selfie con IA…</h3>
				<p class="ss-tip">El procesamiento ocurre en tu dispositivo: tu foto nunca se sube a ningún servidor.</p>
			</div>
		{:else if widget.step === 'editor'}
			<EditorCanvas {widget} />
		{:else if widget.step === 'error'}
			<div class="ss-error">
				<p>⚠ {widget.error}</p>
				<button type="button" class="ss-btn" onclick={() => widget.boot()}>Reintentar</button>
			</div>
		{/if}
	</div>

	<footer class="ss-footer">Powered by SelfieStudio</footer>
</div>
